import React from "react";
import styles from "./CategoriesSection.module.css";

interface Category {
  id: number;
  title: string;
  image: string | null;
  url: string;
}

interface Props {
  sectionTitle?: string;
  categories: Category[];
}

const CategoriesSection: React.FC<Props> = ({ sectionTitle, categories }) => (
  <section className={styles.container}>
    {sectionTitle && <h2 className={styles.title}>{sectionTitle}</h2>}
    <div className={styles.categoriesRow}>
      {categories.map((cat) => (
        <a
          key={cat.id}
          href={`/c/${cat.url}`}
          className={styles.categoryLink}
          aria-label={cat.title}
        >
          <div className={styles.imageWrapper}>
            {cat.image && (
              <img
                src={cat.image}
                alt={cat.title}
                className={styles.categoryImage}
              />
            )}
          </div>
          <div className={styles.categoryTitle}>{cat.title}</div>
        </a>
      ))}
    </div>
  </section>
);

export default CategoriesSection;
